import { render, staticRenderFns } from "./emphasisNursing.vue?vue&type=template&id=0a06fcc8&scoped=true&"
import script from "./emphasisNursing.vue?vue&type=script&lang=js&"
export * from "./emphasisNursing.vue?vue&type=script&lang=js&"
import style0 from "./emphasisNursing.vue?vue&type=style&index=0&id=0a06fcc8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a06fcc8",
  null
  
)

export default component.exports